import { createContext, useState, useEffect} from "react";

export const WordPlayContext = createContext({
    thisWebsite: "~This Very Website~",

});

export const WordPlayProvider = ({children}) => {
    const [thisWebsite, setThisWebsite] = useState("~This Very Website~");
    



    const value = {thisWebsite, setThisWebsite};

    return <WordPlayContext.Provider value={value}>{children}</WordPlayContext.Provider>
}